<div>
  <p>Com mais de 130 anos de história, o Diário Oficial é o principal meio de publicação dos atos oficiais de governo.
  Reconhecido por seu compromisso com a transparência e com a garantia ao acesso às informações públicas, o jornal é um canal de comunicação do governo com a sociedade, dando publicidade aos seus atos, assim como demais matérias de interesse público, como leis, decretos, editais de licitações, avisos, contratos públicos, demonstrativos financeiros, entre outros.</p>

  <h4>Por que escolher o Diário Oficial de Minas Gerais?</h4>
  <ul>
    <li><strong>Tradição</strong>: Desde a sua 1ª edição, impressa em 1892, até as modernas publicações, o jornal guarda a história do Estado, registrando as decisões de governo ao longo de mais de 100 anos.</li>
    <li><strong>Legalidade</strong>: Em conformidade com os rigorosos padrões de segurança, garante autenticidade e integridade da informação publicada.</li>
    <li><strong>Transparência</strong>: Acesso público e gratuito às informações publicadas, assegurada a contínua e permanente veiculação de informações de interesse público no site oficial do Jornal Minas Gerais.</li>
  </ul>

  <div class="acesse-o-sigepo">
    <lib-segov-sigepo-rounded-button (click)="goToSigepo()" (onkeyup.enter)="goToSigepo()"
    [baseStyle]="'segov-rounded-button-with-border'" [width]="'320px'"
    [customStyle]="'border-radius: 5px; font-size: 16px; height: 72px;'">
    Acesse o SIGEPO e publique agora!
    </lib-segov-sigepo-rounded-button>
  </div>
</div>
